export default __webpack_public_path__ + "static/media/draw-table.2e03b805.png";